import arriereBackoffice from '@avantstay/arriere-clients/dist/arriereBackoffice'

export default {
  async getAirbnbSuperhostIndicators(leadSourceAccount: string) {
    return arriereBackoffice.queries
      .globalIndicators({
        __args: {},
        customerExperience: {
          airbnbSuperhostRating: {
            __args: { leadSourceAccount },
          },
          airbnbSuperhostPeriod: {
            start: true,
            end: true,
          },
          airbnbFiveStarReviewsToSuperhost: {
            __args: { leadSourceAccount },
          },
        },
      })
      .then(response => {
        return response.customerExperience
      })
  },
}
